import React from 'react';
import {
  AboutStopsIcon,
  VegetationChangeIcon,
} from 'components/cwo-report-icons';

import {
  DescriptionIcon,
  CombineIcon,
  FieldIcon,
  CopyIcon,
} from 'components/cwo-icons';

const cwoModuleConfig = {
  telematics: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <CombineIcon />
      </span>
    ),
  },
  // eslint-disable-next-line camelcase
  land_management: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <VegetationChangeIcon />
      </span>
    ),
  },
  warehouse: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <DescriptionIcon />
      </span>
    ),
  },
  integrations: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <AboutStopsIcon />
      </span>
    ),
  },
  orchards: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <FieldIcon />
      </span>
    ),
  },
  other: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <CopyIcon />
      </span>
    ),
  },
};
export default cwoModuleConfig;
